/* @ngInject */
const mySaleEditForm = (
  toaster,
  $$sale,
  $$wagon,
  utils
) => {
  return {
    restrict: 'E',
    scope: {
      mySale: '=',
      myWagons: '=',
    },
    template: require('./mySaleEditForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.$$wagon = $$wagon
      $scope.wagon = $$wagon.new.search()
      $scope.wagonIds = []
      $scope.wagonNewIds = []
      $scope.authorizeWagonsNotOnRail = false

      $scope.editSale = async (_sale, _wagonIds, _wagonNewIds) => {
        try {
          const response = await $$sale.request.update(_sale, [..._wagonIds, ..._wagonNewIds,])
          utils.updateFromArray($$sale.data.mySales, response.sale)
          utils.$back()
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default mySaleEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/directives/forms/mySaleEditForm.js